import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { CommonService } from './services/common.service';
import { SharedService } from './services/shared.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnInit {
  isExpanded: boolean = true;
  constructor(private commonService: CommonService,
    private readonly title: Title,
    readonly router: Router,
    readonly sharedService: SharedService
  ) {
    this.title.setTitle("National Distribution Monitor");

    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        let _menu = sharedService.getMenuTitle(event.url);
        if (_menu.title !== "" && _menu.title !== null) {
          this.title.setTitle(_menu.title);
        }
        if (document.getElementById("btnTopMenu")?.getAttribute("aria-expanded") == "true") {
          document.getElementById("btnTopMenu")?.click();
        }
      }
    });
  }

  ngOnInit(): void {
    this.commonService.isExpanded.subscribe(res => {
      this.isExpanded = res;
    });
  }
  onActivate(event: any) {

    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }
}
